import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=0d3a732f&scoped=true&"
import script from "./CurrencyList.vue?vue&type=script&lang=js&"
export * from "./CurrencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a732f",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QBadge} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QBadge}, component.options.components || {})
